import React from 'react';
import { Button } from '@fluentui/react-components';

type TabButtonPropsType = {
  onClick?: () => void;
  text: string;
};

const btnStyle = {
  height: '24px',
  backgroundColor: 'rgb(204, 204, 204)',
};

export const TabButton = ({ onClick, text }: TabButtonPropsType) => {
  return (
    <Button onClick={onClick} style={btnStyle}>
      {text}
    </Button>
  );
};
